{
  "title": "Unearthly Chorus (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "1st-level illusion",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (30-foot radius)",
  "components": "V",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Music of a style you choose fills the air around you in a 30-foot radius. The music spreads around corners and can be heard from up to 100 feet away. The music moves with you, centered on you for the duration.",
    "Until the spell ends, you make Charisma (Performance) checks with advantage. In addition, you can use a bonus action on each of your turns to beguile one creature you choose within 30 feet of you that can see you and hear the music. The creature must make a Charisma saving throw. If you or your companions are attacking it, the creature automatically succeeds on the saving throw. On a failure, the creature becomes friendly to you for as long as it can hear the music and for 1 hour thereafter. You make Charisma (Deception) checks and Charisma (Persuasion) checks against creatures made friendly by this spell with advantage."
  ],
  "spellLists": ["bard"]
}
